import React from 'react';
import { CheckCircle } from 'lucide-react';
import Carousel from '../components/Carousel';

const officeSlides = [
  {
    src: 'https://customer-assets.emergentagent.com/job_726e721e-6ffb-497e-9efe-ad436fa6993e/artifacts/ihrvxju2_WhatsApp%20Image%202026-06-01%20at%204.39.01%20AM.jpeg',
    caption: 'Usha Automation Corporate Office — Bharthal, Dwarka, New Delhi'
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_726e721e-6ffb-497e-9efe-ad436fa6993e/artifacts/dfd9gcxj_WhatsApp%20Image%202026-06-01%20at%204.39.01%20AM%20%281%29.jpeg',
    caption: 'Our team at work — delivering industrial automation solutions'
  }
];

const About = () => {
  return (
    <div>
      <section 
        className="relative py-24 bg-slate-900 text-white overflow-hidden"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?q=80&w=2070&auto=format&fit=crop)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-slate-900/90"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 lg:px-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
            About Usha Automation
          </h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Leading Industrial Automation & IIoT Solutions Provider
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-[#FF7F2A]/10 rounded-sm"></div>
              <img 
                src="https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?q=80&w=2070&auto=format&fit=crop" 
                alt="Industrial automation control panel" 
                className="relative rounded-sm shadow-xl w-full h-auto"
              />
              <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-[#1E56A0]/10 rounded-sm"></div>
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900 mb-8">
                Who We Are
              </h2>
              <div className="space-y-6 text-slate-600 leading-relaxed max-w-2xl">
                <p className="text-lg">
                  <strong className="text-slate-900">Usha Automation</strong> is a leading Industrial Automation and IIoT solutions company specializing in PLC, SCADA, HMI, and control panel solutions.
                </p>
                <p>
                  With proven expertise in Oil & Gas and LPG infrastructure, we deliver reliable, scalable systems prioritizing safety and OISD compliance.
                </p>
                <p>
                  Our certified engineers collaborate closely with clients to create customized automation solutions that drive operational excellence.
                </p>
              </div>
              <div className="mt-8 flex flex-wrap gap-4">
                <div className="flex items-center space-x-2 bg-[#10B981]/10 px-4 py-2 rounded-sm">
                  <CheckCircle className="w-5 h-5 text-[#10B981]" />
                  <span className="font-medium text-slate-900">OISD Certified</span>
                </div>
                <div className="flex items-center space-x-2 bg-[#FF7F2A]/10 px-4 py-2 rounded-sm">
                  <CheckCircle className="w-5 h-5 text-[#FF7F2A]" />
                  <span className="font-medium text-slate-900">24/7 Support</span>
                </div>
                <div className="flex items-center space-x-2 bg-[#1E56A0]/10 px-4 py-2 rounded-sm">
                  <CheckCircle className="w-5 h-5 text-[#1E56A0]" />
                  <span className="font-medium text-slate-900">Expert Team</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white" data-testid="office-infrastructure-section">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900 mb-4">
              Our Office & Infrastructure
            </h2>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto">
              A look inside our corporate office and workspace in Dwarka, New Delhi
            </p>
          </div>
          <Carousel images={officeSlides} testId="about-office-carousel" />
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-8 rounded-sm text-center shadow-sm hover:shadow-lg transition-all duration-300 border-t-4 border-[#1E56A0]">
              <div className="text-5xl font-bold text-[#1E56A0] mb-2">5+</div>
              <p className="text-slate-600 font-medium">Years Experience</p>
            </div>
            <div className="bg-white p-8 rounded-sm text-center shadow-sm hover:shadow-lg transition-all duration-300 border-t-4 border-[#FF7F2A]">
              <div className="text-5xl font-bold text-[#FF7F2A] mb-2">100+</div>
              <p className="text-slate-600 font-medium">Projects Delivered</p>
            </div>
            <div className="bg-white p-8 rounded-sm text-center shadow-sm hover:shadow-lg transition-all duration-300 border-t-4 border-[#1E56A0]">
              <div className="text-5xl font-bold text-[#1E56A0] mb-2">50+</div>
              <p className="text-slate-600 font-medium">Happy Clients</p>
            </div>
            <div className="bg-white p-8 rounded-sm text-center shadow-sm hover:shadow-lg transition-all duration-300 border-t-4 border-[#FF7F2A]">
              <div className="text-5xl font-bold text-[#FF7F2A] mb-2">24/7</div>
              <p className="text-slate-600 font-medium">Support Available</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900 mb-16 text-center">
            Why Choose Usha Automation
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="group hover:bg-slate-50 p-8 rounded-sm transition-all duration-300">
              <div className="bg-[#1E56A0] text-white rounded-sm p-3 w-fit mb-6 group-hover:scale-110 transition-transform">
                <CheckCircle className="w-8 h-8" />
              </div>
              <h3 className="font-semibold text-slate-900 text-xl mb-4">OISD Standards</h3>
              <p className="text-slate-600 leading-relaxed">
                All solutions are designed according to OISD norms and industry safety requirements.
              </p>
            </div>
            <div className="group hover:bg-slate-50 p-8 rounded-sm transition-all duration-300">
              <div className="bg-[#FF7F2A] text-white rounded-sm p-3 w-fit mb-6 group-hover:scale-110 transition-transform">
                <CheckCircle className="w-8 h-8" />
              </div>
              <h3 className="font-semibold text-slate-900 text-xl mb-4">24/7 Support</h3>
              <p className="text-slate-600 leading-relaxed">
                Round-the-clock technical assistance ensuring seamless operations.
              </p>
            </div>
            <div className="group hover:bg-slate-50 p-8 rounded-sm transition-all duration-300">
              <div className="bg-[#1E56A0] text-white rounded-sm p-3 w-fit mb-6 group-hover:scale-110 transition-transform">
                <CheckCircle className="w-8 h-8" />
              </div>
              <h3 className="font-semibold text-slate-900 text-xl mb-4">Expert Team</h3>
              <p className="text-slate-600 leading-relaxed">
                Certified engineers with deep expertise in industrial automation.
              </p>
            </div>
            <div className="group hover:bg-slate-50 p-8 rounded-sm transition-all duration-300">
              <div className="bg-[#FF7F2A] text-white rounded-sm p-3 w-fit mb-6 group-hover:scale-110 transition-transform">
                <CheckCircle className="w-8 h-8" />
              </div>
              <h3 className="font-semibold text-slate-900 text-xl mb-4">Proven Track Record</h3>
              <p className="text-slate-600 leading-relaxed">
                Successfully delivered for IOCL, GAIL, and HPCL.
              </p>
            </div>
            <div className="group hover:bg-slate-50 p-8 rounded-sm transition-all duration-300">
              <div className="bg-[#1E56A0] text-white rounded-sm p-3 w-fit mb-6 group-hover:scale-110 transition-transform">
                <CheckCircle className="w-8 h-8" />
              </div>
              <h3 className="font-semibold text-slate-900 text-xl mb-4">Custom Solutions</h3>
              <p className="text-slate-600 leading-relaxed">
                Tailored systems designed for your operational needs.
              </p>
            </div>
            <div className="group hover:bg-slate-50 p-8 rounded-sm transition-all duration-300">
              <div className="bg-[#FF7F2A] text-white rounded-sm p-3 w-fit mb-6 group-hover:scale-110 transition-transform">
                <CheckCircle className="w-8 h-8" />
              </div>
              <h3 className="font-semibold text-slate-900 text-xl mb-4">Quality Assurance</h3>
              <p className="text-slate-600 leading-relaxed">
                Rigorous testing ensures reliable performance.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
